var map = {
	"./booking.png": 451,
	"./deliveroo.png": 791,
	"./glassdoor.png": 658,
	"./google.png": 537,
	"./justeat.png": 349,
	"./opentable.png": 442,
	"./tripadvisor.png": 489,
	"./trustpilot.png": 816,
	"./ubereats.png": 849,
	"./yelp.png": 734
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22;